import React from "react";

import { useOtpPassword } from "./useOtpPassword.tsx";
import OtpPasswordUI from "./OtpPassword.ui.tsx";

const OtpPassword: React.FC = () => {
  const otpProps = useOtpPassword();

  return <OtpPasswordUI {...otpProps} />;
};

export default OtpPassword;
